import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import AppBar from "../../../common/AppBar.js";
import Snackbar from "../../../common/Snackbar.js";
import RenderHtml from "../../../common/AppSpecificConpnents/PartsTable/RenderHtml.js";
import {
  HeadingWithTreePath,
  generateCompleteTreePath,
} from "../../SubassemblyDetails/utils/treePathUtils.js";

import "../../SubassemblyDetails/SubassemblyDetails.css";
import { getPages, renderPreview, renderVideo } from "../plugins/utils.js";
import { getAllSectionsForPart } from "../../../redux/sectionSlice.js";
import {
  getAllAttachmentsForStep,
  getAllAttachmentsForSubstep,
  getAllCanvasesForStep,
  getAllCanvasesForSubstep,
  getAllFormsForStep,
  getAllFormsForSubstep,
  getAllRichTextsForStep,
  getAllRichTextsForSubstep,
  getAllStepsForSection,
  getAllSubstepsForStep,
  getAllVideosForStep,
  getAllVideosForSubstep,
} from "../../../redux/stepSlice.js";

import CanvasDisplay from "../../Canvas/components/canvas-core/CanvasDisplay.jsx";
import { getMoveCopyInfo } from "../../../util/AppUtils.js";
const ProcedureSubstepMove = () => {
  const [targetSectionData, setTargetSectionData] = useState({});
  const { sections } = useSelector((state) => state.section);
  let richTextCounter = 1;
  let canvasCounter = 1;
  let videoCounter = 1;
  let formCounter = 1;
  const [createCopy, setCreateCopy] = useState(false);
  const [toMoveCopyInfo, setToMoveCopy] = useState({});

  let richTextsCounter = {};

  const location = useLocation();
  const navigate = useNavigate();
  let attachmentCounter = 1;

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    type: "",
  });

  const compareSiblingOrders = (a, b) => {
    const intA = parseInt(a, 10);
    const intB = parseInt(b, 10);
    return intA - intB;
  };

  const {
    type,
    partNumber,
    description,
    revision,
    status,
    title,
    steps,
    revisionId,
    partId,
    fromSectionId,
    fromTreeId,
    fromSiblingOrder,
    fromStepSiblingOrder,
    fromStepId,
    fromStepTreeId,
    fromSubstepId,
    fromSubstepTreeId,
    fromSubstepSiblingOrder,
  } = location.state;
  const [selectedSectionIndex, setSelectedSectionIndex] = useState(null);
  const [selectedStepInfo, setSelectedStepInfo] = useState(null);
  const [selectedNodeInfo, setSelectedNodeInfo] = useState(null);
  const [selectionType, setSelectionType] = useState(null); // 'section', 'step', or 'node'

  const {
    stepsBySection,
    substepsByStep,
    richTexts,
    attachments,
    forms,
    canvases,
    videos,
  } = useSelector((state) => state.step);

  const showSnackbar = (message, type) => {
    setSnackbar({ open: true, message, type });
  };

  const sortedSections = [...sections];

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleCreateCopyChange = () => {
    setCreateCopy(!createCopy);
  };

  const handleMoveUp = () => {
    if (!selectedNodeInfo) {
      showSnackbar("Please select a target node to move above", "error");
      return;
    }

    // Update direction for AppBar title
    setSelectedNodeInfo({
      ...selectedNodeInfo,
      direction: "up",
    });

    // Extract source information from title correctly
    const titleParts = title.split(" ");
    const sourceStepNumber = parseInt(titleParts[1], 10);
    const sourceAttachmentNumber = parseInt(titleParts[2], 10);

    // Log extracted values for debugging
    // If sourceAttachmentNumber is NaN, try alternative parsing
    let finalSourceNodeIndex = sourceAttachmentNumber - 1;
    if (isNaN(sourceAttachmentNumber)) {
      // Try to extract the number from a different part of the title
      const matches = title.match(/Attachment\s+(\d+)/i);
      if (matches && matches[1]) {
        finalSourceNodeIndex = parseInt(matches[1], 10) - 1;
      } else {
        finalSourceNodeIndex = 0; // Default to 0 if no number found
      }
    }

    // Navigate to preview screen
    navigate("/procedure-substep-move-preview", {
      state: {
        ...location.state,
        move_rev_node_info: {
          ...location.state.move_rev_node_info,
          ...toMoveCopyInfo,
        },
        moveType: "up",
        targetSectionIndex: selectedNodeInfo.sectionIndex,
        targetStepIndex: selectedNodeInfo.stepIndex,
        targetNodeIndex: selectedNodeInfo.nodeIndex,
        targetNodeType: selectedNodeInfo.nodeType,
        targetNodeGlobalNumber: selectedNodeInfo.globalNodeNumber,
        sourceStepIndex: sourceStepNumber - 1,
        sourceSectionIndex: location.state.sourceSectionIndex,
        sourceNodeIndex: finalSourceNodeIndex,
        sourceNodeType: "substep",
        movingNode: true,
        sourceStepId: location.state.sourceStepId,
        targetStepId: selectedNodeInfo.stepId,
        sourceSubstepIndex: location.state.sourceSubstepIndex,
        revisionId,
        targetSectionData,
        partId,
        fromSectionId,
        fromTreeId,
        fromSiblingOrder,
        fromStepSiblingOrder,
        fromStepId,
        fromStepTreeId,
        movingSubstep: true,
        fromSubstepId,
        fromSubstepTreeId: fromSubstepTreeId,
        fromSubstepSiblingOrder: fromSubstepSiblingOrder,
        createCopy,
        ...(selectedNodeInfo.substepIndex !== undefined && {
          targetSubstepIndex: selectedNodeInfo.substepIndex,
        }),
      },
    });
  };

  const handleMoveInto = () => {
    if (
      !selectedStepInfo &&
      (!selectedNodeInfo || selectedNodeInfo.nodeType !== "Substep")
    ) {
      showSnackbar(
        "Please select a target step or substep to move into",
        "error"
      );
      return;
    }

    // Extract source information from title correctly
    const titleParts = title.split(" ");
    const sourceStepNumber = parseInt(titleParts[1], 10);
    const sourceAttachmentNumber = parseInt(titleParts[2], 10);

    // Log extracted values for debugging
    // If sourceAttachmentNumber is NaN, try alternative parsing
    let finalSourceNodeIndex = sourceAttachmentNumber - 1;
    if (isNaN(sourceAttachmentNumber)) {
      // Try to extract the number from a different part of the title
      const matches = title.match(/Attachment\s+(\d+)/i);
      if (matches && matches[1]) {
        finalSourceNodeIndex = parseInt(matches[1], 10) - 1;
      } else {
        finalSourceNodeIndex = 0; // Default to 0 if no number found
      }
    }

    // Determine if target is a step or substep
    const isTargetSubstep =
      selectedNodeInfo && selectedNodeInfo.nodeType === "Substep";

    navigate("/procedure-substep-move-preview", {
      state: {
        ...location.state,
        move_rev_node_info: {
          ...location.state.move_rev_node_info,
          ...toMoveCopyInfo,
        },
        moveType: "into",
        targetSectionIndex: isTargetSubstep
          ? selectedNodeInfo.sectionIndex
          : selectedStepInfo.sectionIndex,
        // targetStepIndex: isTargetSubstep
        //   ? selectedNodeInfo.stepIndex
        //   : selectedStepInfo.stepIndex,
        targetStepIndex: selectedStepInfo?.globalStepNumber,
        sourceStepIndex: location.state.sourceStepIndex,
        sourceSectionIndex: location.state.sourceSectionIndex,
        sourceNodeIndex: finalSourceNodeIndex,
        sourceNodeType: "substep",
        movingNode: true,
        sourceStepId: location.state.sourceStepId,
        targetStepId: isTargetSubstep
          ? selectedNodeInfo.stepId
          : selectedStepInfo.stepId,
        sourceSubstepIndex: location.state.sourceSubstepIndex,
        movingSubstep: true,
        revisionId,
        targetSectionData,
        partId,
        fromSectionId,
        fromTreeId,
        fromSiblingOrder,
        fromStepSiblingOrder,
        fromStepId,
        fromStepTreeId,
        fromSubstepId,
        fromSubstepTreeId,
        fromSubstepSiblingOrder,
        createCopy,
        ...(isTargetSubstep && {
          targetSubstepIndex: selectedNodeInfo.substepIndex,
        }),
      },
    });
  };

  const handleMoveBelow = () => {
    if (!selectedNodeInfo) {
      showSnackbar("Please select a target node to move below", "error");
      return;
    }

    // Update direction for AppBar title
    setSelectedNodeInfo({
      ...selectedNodeInfo,
      direction: "below",
    });

    // Extract source information from title correctly
    const titleParts = title.split(" ");
    const sourceStepNumber = parseInt(titleParts[1], 10);
    const sourceAttachmentNumber = parseInt(titleParts[2], 10);

    // Log extracted values for debugging
    // If sourceAttachmentNumber is NaN, try alternative parsing
    let finalSourceNodeIndex = sourceAttachmentNumber - 1;
    if (isNaN(sourceAttachmentNumber)) {
      // Try to extract the number from a different part of the title
      const matches = title.match(/Attachment\s+(\d+)/i);
      if (matches && matches[1]) {
        finalSourceNodeIndex = parseInt(matches[1], 10) - 1;
      } else {
        finalSourceNodeIndex = 0; // Default to 0 if no number found
      }
    }

    // Navigate to preview screen
    navigate("/procedure-substep-move-preview", {
      state: {
        ...location.state,
        move_rev_node_info: {
          ...location.state.move_rev_node_info,
          ...toMoveCopyInfo,
        },
        moveType: "below",
        targetSectionIndex: selectedNodeInfo.sectionIndex,
        targetStepIndex: selectedNodeInfo.stepIndex,
        targetNodeIndex: selectedNodeInfo.nodeIndex,
        targetNodeType: selectedNodeInfo.nodeType,
        targetNodeGlobalNumber: selectedNodeInfo.globalNodeNumber,
        sourceStepIndex: location.state.sourceStepIndex,
        sourceSectionIndex: location.state.sourceSectionIndex,
        sourceNodeIndex: finalSourceNodeIndex,
        sourceNodeType: "substep",
        movingNode: true,
        movingSubstep: true,
        sourceStepId: location.state.sourceStepId,
        targetStepId: selectedNodeInfo.stepId,
        sourceSubstepIndex: location.state.sourceSubstepIndex,
        revisionId,
        targetSectionData,
        partId,
        fromSectionId,
        fromTreeId,
        fromSiblingOrder,
        fromStepSiblingOrder,
        fromStepId,
        fromStepTreeId,
        fromSubstepId,
        fromSubstepTreeId,
        fromSubstepSiblingOrder,
        createCopy,
        ...(selectedNodeInfo.substepIndex !== undefined && {
          targetSubstepIndex: selectedNodeInfo.substepIndex,
        }),
      },
    });
  };

  // Extract source information from title
  const titleParts = title.split(" ");
  const sourceStepNumber = parseInt(titleParts[1]);
  const sourceAttachmentNumber = parseInt(titleParts[2]);

  // Debug log source information
  // Get the buttons to display based on selection type
  const getButtons = () => {
    const buttons = [];

    if (selectionType === "step") {
      // Show Move Into/Copy Into button when step or substep is selected
      buttons.push({
        label: createCopy ? "Paste Into" : "Move Into",
        onClick: handleMoveInto,
      });
    } else if (selectionType === "node") {
      // Only show Move Up/Copy Up and Move Below/Copy Below buttons when node is selected (but not a substep)
      buttons.push({
        label: createCopy ? "Paste Above" : "Move Up",
        onClick: handleMoveUp,
      });
      buttons.push({
        label: createCopy ? "Paste Below" : "Move Below",
        onClick: handleMoveBelow,
      });
    }

    return buttons;
  };

  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      // setShowLoader(true);

      await dispatch(getAllSectionsForPart({ partId, revisionId }));
    })();
  }, [dispatch, partId, revisionId]);

  useEffect(() => {
    if (sections.length > 0) {
      sections.forEach(async (section, index) => {
        await dispatch(
          getAllStepsForSection({
            partId,
            revisionId,
            sectionId: section.section_tree_node_id,
          })
        );
      });
    }
  }, [sections, dispatch, partId, revisionId]);

  useEffect(() => {
    if (Object.keys(stepsBySection).length > 0) {
      Object.entries(stepsBySection).forEach(([sectionId, steps], index) => {
        steps.forEach(async (step) => {
          const { step_tree_node_id: stepId } = step;

          // // Fetch for step-level content
          await dispatch(
            getAllRichTextsForStep({ partId, revisionId, sectionId, stepId })
          );
          await dispatch(
            getAllFormsForStep({ partId, revisionId, sectionId, stepId })
          );
          await dispatch(
            getAllVideosForStep({ partId, revisionId, sectionId, stepId })
          );
          await dispatch(
            getAllAttachmentsForStep({ partId, revisionId, sectionId, stepId })
          );
          await dispatch(
            getAllCanvasesForStep({ partId, revisionId, sectionId, stepId })
          );
          // Fetch substeps (async)
          await dispatch(
            getAllSubstepsForStep({ partId, revisionId, sectionId, stepId })
          ).then((action) => {
            const substeps = action.payload?.substeps || [];
            substeps.forEach((substep) => {
              const substepId = substep.sub_step_tree_node_id;

              dispatch(
                getAllRichTextsForSubstep({
                  partId,
                  revisionId,
                  sectionId,
                  stepId,
                  substepId,
                })
              );
              dispatch(
                getAllFormsForSubstep({
                  partId,
                  revisionId,
                  sectionId,
                  stepId,
                  substepId,
                })
              );
              dispatch(
                getAllVideosForSubstep({
                  partId,
                  revisionId,
                  sectionId,
                  stepId,
                  substepId,
                })
              );
              dispatch(
                getAllAttachmentsForSubstep({
                  partId,
                  revisionId,
                  sectionId,
                  stepId,
                  substepId,
                })
              );
              dispatch(
                getAllCanvasesForSubstep({
                  partId,
                  revisionId,
                  sectionId,
                  stepId,
                  substepId,
                })
              );
            });
          });
          if (index === Object.entries(stepsBySection).length - 1) {
            // setShowLoader(false);
          }
        });
      });
    } else {
      // setShowLoader(false);
    }
  }, [sections, dispatch, partId, revisionId, stepsBySection]);

  return (
    <div>
      <AppBar
        showTablesDropdown={false}
        showBackButton={false}
        showCancelButton={true}
        showCreateCopyCheckbox={true}
        createCopy={createCopy}
        onCreateCopyChange={handleCreateCopyChange}
        title={`${createCopy ? "Copying" : "Moving"} ${title} ${
          selectionType === "step" && selectedStepInfo
            ? `into Step ${selectedStepInfo.globalStepNumber}`
            : selectionType === "node" &&
              selectedNodeInfo &&
              selectedNodeInfo.nodeType === "Substep"
            ? `into ${selectedNodeInfo.nodeType} ${selectedNodeInfo.globalNodeNumber}`
            : selectionType === "node" && selectedNodeInfo
            ? `${selectedNodeInfo.direction === "up" ? "above" : "below"} ${
                selectedNodeInfo.nodeType
              } ${selectedNodeInfo.globalNodeNumber}`
            : ""
        }`}
        buttons={getButtons()}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          padding: "8px 0",
          flexWrap: "wrap", // for responsiveness
        }}
      >
        {/* Checkbox + Title + Description */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            clear: "both",
            marginTop: "20px",
          }}
        >
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
              margin: 0,
              clear: "both",
            }}
          >
            {/* Hide procedure checkbox */}
            <span style={{ fontSize: "20px", fontWeight: 600 }}>
              {type} {partNumber}
            </span>
          </label>

          {/* Description */}
          {/* <span style={{ marginLeft: "2px", marginTop: "5px", color: "#666" }}>
            Description: {description}
          </span> */}
        </div>

        {/* Right-aligned section */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            marginLeft: "auto",
            clear: "both",
            marginTop: "20px",
          }}
        >
          <div>
            <strong>Status: </strong>
            <span style={{ color: "orange" }}>Not Submitted</span>
            {/* <span style={{ color: "orange" }}>{status}</span> */}
          </div>

          <div>
            <strong>Revision: </strong>
            <span>{revision}</span>
          </div>
        </div>
      </div>

      {sortedSections
        .sort((a, b) => {
          const orderA = a.sibling_order || a.procedure_tree?.sibling_order;
          const orderB = b.sibling_order || b.procedure_tree?.sibling_order;

          const orderCompare = compareSiblingOrders(orderA, orderB);
          if (orderCompare !== 0) return orderCompare;

          // Fallback: compare created_at
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);
          return dateB - dateA; // latest comes first
        })
        .map((section, index) => {
          const selectedSection =
            index + 1 === selectedSectionIndex ||
            steps[0].procedure_tree.section_id_ref ==
              section.section_tree_node_id;

          const isDisabled = selectedSection || index === selectedSectionIndex;
          const sectionHeading = `Section ${index + 1}`;
          return (
            <div
              key={section.section_tree_node_id}
              style={{
                margin: "20px 0",
                clear: "both",
                marginTop: "20px",
              }}
            >
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  cursor: "pointer",
                  clear: "both",
                  marginTop: "20px",
                }}
              >
                {/* Hide section checkbox */}
                {/* Simple heading for sections without tree path */}
                <h2
                  style={{
                    fontSize: "20px",
                    margin: 0, // Blue color for all sections
                  }}
                >
                  {sectionHeading}
                </h2>
              </label>
              <hr />
              <hr />
              <div>{section.section_name}</div>
              <div>{section.short_description}</div>

              {/* Steps for this section */}
              {(stepsBySection[section.section_tree_node_id] || []).map(
                (step, stepIndex) => {
                  const stepId = step.step_tree_node_id;

                  const stepsBeforeThisSection = sortedSections
                    .slice(0, index)
                    .reduce(
                      (acc, s) =>
                        acc +
                        (stepsBySection[s.section_tree_node_id]?.length || 0),
                      0
                    );
                  const globalStepNumber =
                    stepsBeforeThisSection + stepIndex + 1;

                  // Check if this is the source step that contains the attachment being moved
                  const isSourceStep = globalStepNumber === sourceStepNumber;

                  const myVideos = videos[stepId] || [];
                  const myForms = forms[stepId] || [];
                  const myCanvases = canvases[stepId] || [];
                  const myRichTexts = richTexts[stepId] || [];

                  const currentRichTextCounter = richTextCounter;

                  richTextsCounter[stepId] = currentRichTextCounter;

                  const combinedItems = [
                    ...(richTexts[stepId] || []).map((item) => ({
                      ...item,
                      type: "richText",
                      substep_id_ref: null,
                      step_id_ref: stepId,
                    })),
                    ...(forms[stepId] || []).map((item) => ({
                      ...item,
                      type: "form",
                      substep_id_ref: null,
                      step_id_ref: stepId,
                    })),
                    ...(attachments[stepId] || []).map((item) => ({
                      ...item,
                      type: "attachment",
                      substep_id_ref: null,
                      step_id_ref: stepId,
                    })),
                    ...(canvases[stepId] || []).map((item) => ({
                      ...item,
                      type: "canvas",
                      substep_id_ref: null,
                      step_id_ref: stepId,
                    })),
                    ...(videos[stepId] || []).map((item) => ({
                      ...item,
                      type: "video",
                      substep_id_ref: null,
                      step_id_ref: stepId,
                    })),
                  ]; // Filter out substeps or unwanted items (same as your current filter)
                  const filteredItems = combinedItems.filter(
                    (item) =>
                      !item.substep_id_ref && !item.sub_step_tree_node_id
                  );

                  filteredItems.sort((a, b) => {
                    const orderA =
                      a.sibling_order || a.procedure_tree?.sibling_order;
                    const orderB =
                      b.sibling_order || b.procedure_tree?.sibling_order;

                    const orderCompare = compareSiblingOrders(orderA, orderB);
                    if (orderCompare !== 0) return orderCompare;

                    // Fallback: compare created_at
                    const dateA = new Date(a.created_at);
                    const dateB = new Date(b.created_at);
                    return dateB - dateA; // latest comes first
                  });
                  const allChildItems = [
                    ...(richTexts[stepId] || []),
                    ...(forms[stepId] || []),
                    ...(attachments[stepId] || []),
                    ...(canvases[stepId] || []),
                    ...(videos[stepId] || []),
                  ];

                  // Find the highest sibling_order among all step children
                  const highestSiblingOrder = allChildItems.reduce(
                    (max, item) => {
                      const order =
                        item.sibling_order ??
                        item.procedure_tree?.sibling_order ??
                        -1; // fallback for undefined

                      return Math.max(max, order);
                    },
                    -1
                  );
                  const stepHeading = `Step ${globalStepNumber}`;
                  return (
                    <div
                      key={stepId}
                      style={{ marginTop: "20px", clear: "both" }}
                    >
                      <label
                        style={{
                          display: "flex",
                          gap: "8px",
                          cursor: "pointer",
                          clear: "both",
                        }}
                      >
                        <input
                          type="checkbox"
                          onChange={() => {
                            if (
                              selectedStepInfo &&
                              selectedStepInfo.stepId === stepId
                            ) {
                              setSelectedStepInfo(null);
                              setSelectionType(null);
                            } else {
                              const siblingOrders = stepsBySection[
                                section.section_tree_node_id
                              ].map((item) => {
                                return (
                                  item.sibling_order ||
                                  item.procedure_tree?.sibling_order ||
                                  "0"
                                );
                              });

                              // Find highest using compareSiblingOrders logic
                              const highestSiblingOrder = siblingOrders.reduce(
                                (max, current) => {
                                  return compareSiblingOrders(current, max) > 0
                                    ? current
                                    : max;
                                },
                                "0"
                              );
                              setSelectedStepInfo({
                                stepId,
                                sectionIndex: index,
                                stepIndex,
                                globalStepNumber,
                              });
                              setTargetSectionData({
                                sectionId: section.section_tree_node_id,
                                siblingOrder: section.sibling_order,
                                sectionTreeId: section.section_tree_node_id,
                                stepId,
                                stepTreeId: step.procedure_tree_ref,
                                stepSiblingOrder: highestSiblingOrder,
                                substepSiblingOrder: highestSiblingOrder,
                              });
                              setSelectionType("step");
                            }
                            setToMoveCopy(
                              getMoveCopyInfo(
                                "to",
                                sectionHeading,
                                stepHeading,
                                null,
                                null
                              )
                            );
                          }}
                          checked={
                            selectedStepInfo &&
                            selectedStepInfo.stepId === stepId
                          }
                          style={
                            location.state.fromStepId === stepId
                              ? {
                                  accentColor: "#444444", // Dark grey for step being moved
                                  backgroundColor: "#444444",
                                }
                              : {
                                  accentColor: "#0d6efd", // Blue color for other steps
                                  backgroundColor: "#0d6efd",
                                }
                          }
                          disabled={
                            selectedNodeInfo &&
                            selectedNodeInfo.stepIndex === stepIndex
                          } // Steps are always enabled
                        />

                        <HeadingWithTreePath
                          title={stepHeading}
                          treePathParams={{
                            sectionIndex: index,
                            stepIndex: globalStepNumber - 1,
                            substepIndex: undefined,
                            nodeType: undefined,
                            nodeIndex: undefined,
                          }}
                          color="#0d6efd" // Blue color for all steps
                        />
                      </label>
                      <hr />
                      <p style={{ whiteSpace: 'pre-wrap' }}>{step.short_description || ""}</p>
                      <p>
                        <p>
                          {structuredClone(step.step_details)
                            .sort(
                              (a, b) =>
                                new Date(a.created_at) - new Date(b.created_at)
                            )
                            .map((myStep) => {
                              const partNumber =
                                myStep.part_info?.part_number || "";
                              const description =
                                myStep.part_info?.description || "";
                              const qtyText =
                                myStep.qty && myStep.qty != 0
                                  ? `Qty ${myStep.qty}`
                                  : "";

                              const partText = partNumber
                                ? ` (${partNumber})`
                                : "";

                              return (
                                <>
                                  {myStep.action}
                                  {partText}{" "}
                                  <RenderHtml content={description} /> {qtyText}
                                  &nbsp;
                                </>
                              );
                            })}
                        </p>
                      </p>

                      <h4>{step.bom_table_title_info?.category_name || ""}</h4>

                      <table className="table">
                        <thead>
                          <tr>
                            <th>Type</th>
                            <th>
                              {
                                step.part_number_column_title_ref_info
                                  ?.category_name
                              }{" "}
                            </th>
                            <th>Description</th>
                            <th>Qty Per</th>
                            <th>Unit</th>
                          </tr>
                        </thead>

                        <tbody>
                          {step.parts_required.map((row) => (
                            <tr>
                              <td>{row.part_info.type_info.name}</td>
                              <td>{row.part_info.part_number}</td>
                              <td>
                                <RenderHtml
                                  content={row.part_info.description}
                                />{" "}
                              </td>
                              <td>{row.qty === 0 ? "" : row.qty}</td>
                              <td>{row.part_info?.unit_info?.unit_name}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      {/* Step Content */}
                      {filteredItems.map((item, itemIndex) => {
                        if (item.substep_id_ref || item.sub_step_tree_node_id)
                          return null;

                        // Pre-calculate node numbers for comparison before incrementing counters
                        const currentAttachmentNumber = attachmentCounter;
                        const currentRichTextNumber = richTextCounter;
                        const currentCanvasNumber = canvasCounter;
                        const currentVideoNumber = videoCounter;
                        const currentFormNumber = formCounter;

                        // Debug log counters when in source step
                        if (isSourceStep) {
                        }

                        // Determine if this is the source attachment being moved
                        const isSourceItem =
                          isSourceStep &&
                          ((item.type === "attachment" &&
                            currentAttachmentNumber ===
                              sourceAttachmentNumber) ||
                            (item.type === "richText" &&
                              currentRichTextNumber ===
                                sourceAttachmentNumber) ||
                            (item.type === "canvas" &&
                              currentCanvasNumber === sourceAttachmentNumber) ||
                            (item.type === "video" &&
                              currentVideoNumber === sourceAttachmentNumber) ||
                            (item.type === "form" &&
                              currentFormNumber === sourceAttachmentNumber));

                        // Debug log if this is the source item
                        if (isSourceItem) {
                        }

                        switch (item.type) {
                          case "richText": {
                            const globalRichTextNumber = richTextCounter++; // ✅ use then increment
                            // render richText block here
                            const label = (
                              <HeadingWithTreePath
                                title={`Rich Text ${globalRichTextNumber}`}
                                treePathParams={{
                                  sectionIndex: index,
                                  stepIndex: globalStepNumber - 1,
                                  substepIndex: undefined,
                                  nodeType: "richText",
                                  nodeIndex: globalRichTextNumber - 1,
                                }}
                              />
                            );

                            // Check if this item is within the substep being moved
                            const isInMovingSubstep = false;

                            return (
                              <div
                                key={item.rich_text_tree_node_id}
                                style={{ marginTop: "20px", clear: "both" }}
                              >
                                <label
                                  style={{
                                    display: "flex",
                                    gap: "6px",
                                    cursor: "pointer",
                                    clear: "both",
                                  }}
                                >
                                  {/* Removed disabled checkbox indicator for moving substep */}
                                  {label}
                                </label>

                                <div
                                  style={{
                                    marginLeft: "5px",
                                    marginTop: "-10px",
                                    clear: "both",
                                  }}
                                >
                                  {item.short_description}
                                </div>
                                {item.category_data && (
                                  <div
                                    style={{
                                      marginLeft: "4px",
                                      marginTop: "5px",
                                      clear: "both",
                                    }}
                                  >
                                    {item.category_data.category_name}
                                  </div>
                                )}
                                <div
                                  style={{
                                    fontSize: "14px",
                                    marginLeft: "4px",
                                    marginTop: "5px",
                                    clear: "both",
                                  }}
                                >
                                  <div
                                    style={{ marginTop: "-6px", clear: "both" }}
                                    dangerouslySetInnerHTML={{
                                      __html: item.rich_text_content,
                                    }}
                                  />
                                </div>
                              </div>
                            );
                          }
                          case "video": {
                            const globalVideoNumber = videoCounter++; // ✅ use then increment
                            const label = (
                              <HeadingWithTreePath
                                title={`Video ${globalVideoNumber}`}
                                treePathParams={{
                                  sectionIndex: index,
                                  stepIndex: globalStepNumber - 1,
                                  substepIndex: undefined,
                                  nodeType: "video",
                                  nodeIndex: globalVideoNumber - 1,
                                }}
                              />
                            );

                            // Check if this item is within the substep being moved
                            const isInMovingSubstep = false;

                            return (
                              <div
                                key={item.video_tree_node_id || label}
                                style={{ marginTop: "20px", clear: "both" }}
                              >
                                <label
                                  style={{
                                    display: "flex",
                                    gap: "6px",
                                    cursor: "pointer",
                                    clear: "both",
                                  }}
                                >
                                  {/* Removed disabled checkbox indicator for moving substep */}
                                  {label}
                                </label>

                                {renderVideo(item)}

                                <div>{item.video_url}</div>

                                <div>{item.short_description}</div>
                              </div>
                            );
                          }

                          case "form": {
                            const globalFormNumber = formCounter++; // ✅ use then increment
                            const label = (
                              <HeadingWithTreePath
                                title={`Form ${globalFormNumber}`}
                                treePathParams={{
                                  sectionIndex: index,
                                  stepIndex: globalStepNumber - 1,
                                  substepIndex: undefined,
                                  nodeType: "form",
                                  nodeIndex: globalFormNumber - 1,
                                }}
                              />
                            );

                            // Check if this item is within the substep being moved
                            const isInMovingSubstep = false;

                            return (
                              <div key={item.form_tree_node_id || label}>
                                <label
                                  style={{
                                    display: "flex",
                                    gap: "6px",
                                    cursor: "pointer",
                                    marginTop: "20px",
                                    clear: "both",
                                  }}
                                >
                                  {item.isInMovingSubstep && (
                                    <input
                                      type="checkbox"
                                      checked={true}
                                      disabled={true}
                                      style={{
                                        accentColor: "#444444",
                                        backgroundColor: "#444444",
                                      }}
                                    />
                                  )}
                                  {label}
                                </label>
                                <div>{item.short_description}</div>
                              </div>
                            );
                          }
                          case "canvas": {
                            const pages = getPages(item);

                            const globalCanvasNumber = canvasCounter++; // ✅ use then increment
                            const label = (
                              <HeadingWithTreePath
                                title={`Canvas ${globalCanvasNumber}`}
                                treePathParams={{
                                  sectionIndex: index,
                                  stepIndex: globalStepNumber - 1,
                                  substepIndex: undefined,
                                  nodeType: "canvas",
                                  nodeIndex: globalCanvasNumber - 1,
                                }}
                              />
                            );

                            // Check if this item is within the substep being moved
                            const isInMovingSubstep = false;

                            return (
                              <div
                                key={item.canvas_tree_node_id || label}
                                style={{ marginTop: "40px", clear: "both" }}
                              >
                                <label
                                  style={{
                                    display: "flex",
                                    gap: "6px",
                                    cursor: "pointer",
                                    clear: "both",
                                  }}
                                >
                                  {item.isInMovingSubstep && (
                                    <input
                                      type="checkbox"
                                      checked={true}
                                      disabled={true}
                                      style={{
                                        accentColor: "#444444",
                                        backgroundColor: "#444444",
                                      }}
                                    />
                                  )}
                                  {label}
                                </label>

                                {/* Display all pages vertically */}
                                <CanvasDisplay pages={pages} />
                              </div>
                            );
                          }
                          case "attachment": {
                            const attachmentList = item.attachments || [];
                            if (attachmentList.length === 0) return null;

                            const globalAttachmentNumber = attachmentCounter;
                            attachmentCounter++; // Increment after using the value

                            // Debug log attachment number in source step
                            if (isSourceStep) {
                            }

                            const label = (
                              <HeadingWithTreePath
                                title={`Attachment ${globalAttachmentNumber}`}
                                treePathParams={{
                                  sectionIndex: index,
                                  stepIndex: globalStepNumber - 1,
                                  substepIndex: undefined,
                                  nodeType: "attachment",
                                  nodeIndex: globalAttachmentNumber - 1,
                                }}
                              />
                            );

                            return (
                              <div
                                key={
                                  item.attachment_tree_node_id ||
                                  `attachment-${itemIndex}`
                                }
                                style={{ clear: "both" }}
                              >
                                <label
                                  style={{
                                    display: "flex",
                                    gap: "6px",
                                    cursor: "pointer",
                                    marginTop: "20px",
                                    clear: "both",
                                  }}
                                >
                                  {item.isInMovingSubstep && (
                                    <input
                                      type="checkbox"
                                      checked={true}
                                      disabled={true}
                                      style={{
                                        accentColor: "#444444",
                                        backgroundColor: "#444444",
                                        clear: "both",
                                      }}
                                    />
                                  )}
                                  {label}
                                </label>
                                <div>{item.short_description}</div>
                                {attachmentList.map((attachment, i) => (
                                  <div
                                    key={i}
                                    style={{
                                      marginLeft: "20px",
                                      clear: "both",
                                    }}
                                  >
                                    {renderPreview(attachment)}
                                  </div>
                                ))}
                              </div>
                            );
                          }
                          default:
                            return null;
                        }
                      })}

                      {/* Substeps */}
                      {(substepsByStep[stepId] || []).map(
                        (substep, substepIndex) => {
                          const substepId = substep.sub_step_tree_node_id;
                          // Flag to check if this is the substep being moved
                          const isMovingThisSubstep =
                            fromSubstepId === substepId;

                          const combinedItems = [
                            ...(richTexts[substepId] || []).map((item) => ({
                              ...item,
                              type: "richText",
                              substep_id_ref: substepId,
                              step_id_ref: stepId,
                              isInMovingSubstep: isMovingThisSubstep,
                            })),
                            ...(forms[substepId] || []).map((item) => ({
                              ...item,
                              type: "form",
                              substep_id_ref: substepId,
                              step_id_ref: stepId,
                              isInMovingSubstep: isMovingThisSubstep,
                            })),
                            ...(attachments[substepId] || []).map((item) => ({
                              ...item,
                              type: "attachment",
                              substep_id_ref: substepId,
                              step_id_ref: stepId,
                              isInMovingSubstep: isMovingThisSubstep,
                            })),
                            ...(canvases[substepId] || []).map((item) => ({
                              ...item,
                              type: "canvas",
                              substep_id_ref: substepId,
                              step_id_ref: stepId,
                              isInMovingSubstep: isMovingThisSubstep,
                            })),
                            ...(videos[substepId] || []).map((item) => ({
                              ...item,
                              type: "video",
                              substep_id_ref: substepId,
                              step_id_ref: stepId,
                              isInMovingSubstep: isMovingThisSubstep,
                            })),
                          ]; // Filter out substeps or unwanted items (same as your current filter)
                          const filteredItems = combinedItems;

                          filteredItems.sort((a, b) => {
                            const orderA =
                              a.sibling_order ||
                              a.procedure_tree?.sibling_order;
                            const orderB =
                              b.sibling_order ||
                              b.procedure_tree?.sibling_order;

                            const orderCompare = compareSiblingOrders(
                              orderA,
                              orderB
                            );
                            if (orderCompare !== 0) return orderCompare;

                            // Fallback: compare created_at
                            const dateA = new Date(a.created_at);
                            const dateB = new Date(b.created_at);
                            return dateB - dateA; // latest comes first
                          });

                          // Global step number (same logic you already use for steps)
                          const stepsBeforeThisOne =
                            sortedSections
                              .slice(0, index)
                              .reduce((sectionAcc, s) => {
                                const steps =
                                  stepsBySection[s.section_tree_node_id] || [];
                                return sectionAcc + steps.length;
                              }, 0) + stepIndex;

                          const globalStepNumber = stepsBeforeThisOne + 1;

                          // Final substep label like Substep 5A
                          const substepLetter = String.fromCharCode(
                            65 + substepIndex
                          ); // A, B, C, ...

                          const globalSubstepLabel = `Substep ${globalStepNumber}${substepLetter}`;

                          const isSelectedSubstep =
                            globalSubstepLabel === title;

                          return (
                            <div
                              key={substepId}
                              style={{ marginTop: "20px", clear: "both" }}
                            >
                              <div>
                                <label
                                  style={{
                                    display: "flex",
                                    gap: "8px",
                                    cursor: "pointer",
                                    clear: "both",
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    onChange={() => {
                                      if (
                                        selectedNodeInfo &&
                                        (selectedNodeInfo.nodeId ===
                                          substepId ||
                                          selectedNodeInfo.substepIndex ===
                                            substepIndex)
                                      ) {
                                        setSelectedNodeInfo(null);
                                        setSelectionType(null);
                                      } else {
                                        setSelectedNodeInfo({
                                          nodeId: substepId,
                                          sectionIndex: index,
                                          stepIndex: stepIndex,
                                          substepIndex: substepIndex,
                                          globalNodeNumber: `${globalStepNumber}${substepLetter}`,
                                          nodeType: "Substep",
                                          direction: null,
                                          stepId,
                                        });
                                        setTargetSectionData({
                                          sectionId:
                                            section.section_tree_node_id,
                                          siblingOrder: section.sibling_order,
                                          sectionTreeId:
                                            section.section_tree_node_id,
                                          stepId,
                                          stepTreeId: step.procedure_tree_ref,
                                          stepSiblingOrder:
                                            step.sibling_order ||
                                            step.procedure_tree?.sibling_order,
                                          substepId,
                                          substepTreeId:
                                            substep.procedure_tree_ref,
                                          substepSiblingOrder:
                                            substep.sibling_order ||
                                            substep.procedure_tree
                                              ?.sibling_order,
                                        });
                                        setSelectionType("node");
                                      }
                                      setToMoveCopy(
                                        getMoveCopyInfo(
                                          "to",
                                          sectionHeading,
                                          stepHeading,
                                          globalSubstepLabel,
                                          null
                                        )
                                      );
                                    }}
                                    checked={
                                      isSelectedSubstep ||
                                      (selectedNodeInfo &&
                                        selectedNodeInfo.nodeId === substepId)
                                    }
                                    style={
                                      fromSubstepId === substepId
                                        ? {
                                            accentColor: "#444444", // Dark grey for substep being moved
                                            backgroundColor: "#444444",
                                          }
                                        : {
                                            accentColor: "#0d6efd", // Blue color for other substeps
                                            backgroundColor: "#0d6efd",
                                          }
                                    }
                                  />
                                  <HeadingWithTreePath
                                    title={globalSubstepLabel}
                                    treePathParams={{
                                      sectionIndex: index,
                                      stepIndex: globalStepNumber - 1,
                                      substepIndex: substepIndex,
                                      nodeType: undefined,
                                      nodeIndex: undefined,
                                    }}
                                    color={
                                      fromSubstepId === substepId
                                        ? "#444444"
                                        : "#0d6efd"
                                    } // Dark grey for substep being moved, blue for others
                                  />
                                </label>

                                <div style={{ whiteSpace: 'pre-wrap' }}>{substep.short_description}</div>
                              </div>

                              {/* Substep content */}

                              {filteredItems.map((item, itemIndex) => {
                                // Pre-calculate node numbers for comparison before incrementing counters
                                const currentAttachmentNumber =
                                  attachmentCounter;
                                const currentRichTextNumber = richTextCounter;
                                const currentCanvasNumber = canvasCounter;
                                const currentVideoNumber = videoCounter;
                                const currentFormNumber = formCounter;

                                // Debug log counters when in source step
                                if (isSourceStep) {
                                }

                                // Determine if this is the source attachment being moved
                                const isSourceItem =
                                  isSourceStep &&
                                  ((item.type === "attachment" &&
                                    currentAttachmentNumber ===
                                      sourceAttachmentNumber) ||
                                    (item.type === "richText" &&
                                      currentRichTextNumber ===
                                        sourceAttachmentNumber) ||
                                    (item.type === "canvas" &&
                                      currentCanvasNumber ===
                                        sourceAttachmentNumber) ||
                                    (item.type === "video" &&
                                      currentVideoNumber ===
                                        sourceAttachmentNumber) ||
                                    (item.type === "form" &&
                                      currentFormNumber ===
                                        sourceAttachmentNumber));

                                // Debug log if this is the source item
                                if (isSourceItem) {
                                }

                                switch (item.type) {
                                  case "richText": {
                                    const globalRichTextNumber =
                                      richTextCounter++; // ✅ use then increment
                                    // render richText block here
                                    const label = (
                                      <HeadingWithTreePath
                                        title={`Rich Text ${globalRichTextNumber}`}
                                        treePathParams={{
                                          sectionIndex: index,
                                          stepIndex: globalStepNumber - 1,
                                          substepIndex: substepIndex,
                                          nodeType: "richText",
                                          nodeIndex: globalRichTextNumber - 1,
                                        }}
                                      />
                                    );

                                    // We no longer use this variable to avoid undefined reference errors

                                    return (
                                      <div
                                        key={item.rich_text_tree_node_id}
                                        style={{
                                          marginTop: "20px",
                                          clear: "both",
                                        }}
                                      >
                                        <label
                                          style={{
                                            display: "flex",
                                            gap: "6px",
                                            cursor: "pointer",
                                            clear: "both",
                                          }}
                                        >
                                          {/* Removed disabled checkbox indicator for moving substep */}
                                          {label}
                                        </label>

                                        <div
                                          style={{
                                            marginLeft: "5px",
                                            marginTop: "-10px",
                                            clear: "both",
                                          }}
                                        >
                                          {item.short_description}
                                        </div>
                                        {item.category_data && (
                                          <div
                                            style={{
                                              marginLeft: "4px",
                                              marginTop: "5px",
                                              clear: "both",
                                            }}
                                          >
                                            {item.category_data.category_name}
                                          </div>
                                        )}
                                        <div
                                          style={{
                                            fontSize: "14px",
                                            marginLeft: "4px",
                                            marginTop: "5px",
                                            clear: "both",
                                          }}
                                        >
                                          <div
                                            style={{
                                              marginTop: "-6px",
                                              clear: "both",
                                            }}
                                            dangerouslySetInnerHTML={{
                                              __html: item.rich_text_content,
                                            }}
                                          />
                                        </div>
                                      </div>
                                    );
                                  }
                                  case "video": {
                                    const globalVideoNumber = videoCounter++; // ✅ use then increment
                                    const label = (
                                      <HeadingWithTreePath
                                        title={`Video ${globalVideoNumber}`}
                                        treePathParams={{
                                          sectionIndex: index,
                                          stepIndex: globalStepNumber - 1,
                                          substepIndex: substepIndex,
                                          nodeType: "video",
                                          nodeIndex: globalVideoNumber - 1,
                                        }}
                                      />
                                    );

                                    // We no longer use this variable to avoid undefined reference errors

                                    return (
                                      <div
                                        key={item.video_tree_node_id || label}
                                        style={{
                                          marginTop: "20px",
                                          clear: "both",
                                        }}
                                      >
                                        <label
                                          style={{
                                            display: "flex",
                                            gap: "6px",
                                            cursor: "pointer",
                                            clear: "both",
                                          }}
                                        >
                                          {item.isInMovingSubstep && (
                                            <input
                                              type="checkbox"
                                              checked={true}
                                              disabled={true}
                                              style={{
                                                accentColor: "#444444",
                                                backgroundColor: "#444444",
                                                clear: "both",
                                              }}
                                            />
                                          )}
                                          {label}
                                        </label>

                                        {renderVideo(item)}

                                        <div>{item.video_url}</div>

                                        <div>{item.short_description}</div>
                                      </div>
                                    );
                                  }

                                  case "form": {
                                    const globalFormNumber = formCounter++; // ✅ use then increment
                                    const label = (
                                      <HeadingWithTreePath
                                        title={`Form ${globalFormNumber}`}
                                        treePathParams={{
                                          sectionIndex: index,
                                          stepIndex: globalStepNumber - 1,
                                          substepIndex: substepIndex,
                                          nodeType: "form",
                                          nodeIndex: globalFormNumber - 1,
                                        }}
                                      />
                                    );

                                    // We no longer use this variable to avoid undefined reference errors

                                    return (
                                      <div
                                        key={item.form_tree_node_id || label}
                                        style={{ clear: "both" }}
                                      >
                                        <label
                                          style={{
                                            display: "flex",
                                            gap: "6px",
                                            cursor: "pointer",
                                            marginTop: "20px",
                                            clear: "both",
                                          }}
                                        >
                                          {item.isInMovingSubstep && (
                                            <input
                                              type="checkbox"
                                              checked={true}
                                              disabled={true}
                                              style={{
                                                accentColor: "#444444",
                                                backgroundColor: "#444444",
                                                clear: "both",
                                              }}
                                            />
                                          )}
                                          {label}
                                        </label>
                                        <div>{item.short_description}</div>
                                      </div>
                                    );
                                  }
                                  case "canvas": {
                                    const pages = getPages(item);

                                    const globalCanvasNumber = canvasCounter++; // ✅ use then increment
                                    const label = (
                                      <HeadingWithTreePath
                                        title={`Canvas ${globalCanvasNumber}`}
                                        treePathParams={{
                                          sectionIndex: index,
                                          stepIndex: globalStepNumber - 1,
                                          substepIndex: substepIndex,
                                          nodeType: "canvas",
                                          nodeIndex: globalCanvasNumber - 1,
                                        }}
                                      />
                                    );

                                    // We no longer use this variable to avoid undefined reference errors

                                    return (
                                      <div
                                        key={item.canvas_tree_node_id || label}
                                        style={{
                                          marginTop: "40px",
                                          clear: "both",
                                        }}
                                      >
                                        <label
                                          style={{
                                            display: "flex",
                                            gap: "6px",
                                            cursor: "pointer",
                                            clear: "both",
                                          }}
                                        >
                                          {item.isInMovingSubstep && (
                                            <input
                                              type="checkbox"
                                              checked={true}
                                              disabled={true}
                                              style={{
                                                accentColor: "#444444",
                                                backgroundColor: "#444444",
                                                clear: "both",
                                              }}
                                            />
                                          )}
                                          {label}
                                        </label>

                                        {/* Display all pages vertically */}
                                        <CanvasDisplay pages={pages} />
                                      </div>
                                    );
                                  }
                                  case "attachment": {
                                    const attachmentList =
                                      item.attachments || [];
                                    if (attachmentList.length === 0)
                                      return null;

                                    const globalAttachmentNumber =
                                      attachmentCounter;
                                    attachmentCounter++; // Increment after using the value

                                    // Debug log attachment number in source step
                                    if (isSourceStep) {
                                    }

                                    const label = (
                                      <HeadingWithTreePath
                                        title={`Attachment ${globalAttachmentNumber}`}
                                        treePathParams={{
                                          sectionIndex: index,
                                          stepIndex: globalStepNumber - 1,
                                          substepIndex: substepIndex,
                                          nodeType: "attachment",
                                          nodeIndex: globalAttachmentNumber - 1,
                                        }}
                                      />
                                    );

                                    // Determine if this is the source attachment using a direct comparison
                                    // This is a more straightforward way to identify the attachment being moved
                                    const isMovingThisAttachment =
                                      (isSourceStep &&
                                        globalAttachmentNumber ===
                                          sourceAttachmentNumber) ||
                                      title.split(" ")[1] ===
                                        globalAttachmentNumber.toString();

                                    // We no longer use this variable to avoid undefined reference errors

                                    // Debug log disabled state
                                    return (
                                      <div
                                        key={
                                          item.attachment_tree_node_id ||
                                          `attachment-${itemIndex}`
                                        }
                                        style={{ clear: "both" }}
                                      >
                                        <label
                                          style={{
                                            display: "flex",
                                            gap: "6px",
                                            cursor: "pointer",
                                            marginTop: "20px",
                                            clear: "both",
                                          }}
                                        >
                                          {item.isInMovingSubstep && (
                                            <input
                                              type="checkbox"
                                              checked={true}
                                              disabled={true}
                                              style={{
                                                accentColor: "#444444",
                                                backgroundColor: "#444444",
                                                clear: "both",
                                              }}
                                            />
                                          )}
                                          {label}
                                        </label>
                                        <div>{item.short_description}</div>
                                        {attachmentList.map((attachment, i) => (
                                          <div
                                            key={i}
                                            style={{
                                              marginLeft: "20px",
                                              clear: "both",
                                            }}
                                          >
                                            {renderPreview(attachment)}
                                          </div>
                                        ))}
                                      </div>
                                    );
                                  }
                                  default:
                                    return null;
                                }
                              })}
                            </div>
                          );
                        }
                      )}
                    </div>
                  );
                }
              )}
            </div>
          );
        })}

      {snackbar.open && (
        <Snackbar
          message={snackbar.message}
          type={snackbar.type}
          onClose={handleCloseSnackbar}
        />
      )}
      <div style={{ height: "100px" }}></div>
    </div>
  );
};
export default ProcedureSubstepMove;
